import axios from 'axios'
import qs from 'qs'
import {
  getToken
} from '@/utils/token'
import router from '../router'
// create an axios instance
axios.defaults.headers.get['Content-Type'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000, // request timeout
})

// 请求前置拦截
service.interceptors.request.use(
  async config => {
      // 统一增加token
      // const token = sessionStorage['token']
      const language = sessionStorage['lang']
      // if (token) {
      //   config.headers = {
      //     Authorization: 'Bearer ' + token,

      //   }
      // }
      if (config.method === 'get') {
        config.params.language = language
      } else if (config.method === 'post') {
        config.data.language = language
      }
      return config
    },
    error => {
      // 错误处理
      Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
  function (response) {
    // ①10010 token过期（30天） ②10011 token无效
    // console.log(response.data)
    // if ([1003, 1001, 1002, 1004, 1005].includes(Number(response.data.code))) {
    //   // Storage.localRemove('token') // 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）
    //   router.replace({
    //     path: '/' // 到登录页重新获取token
    //   })
    // }

    return response.data
  },
  function (error) {
    // if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    //   Notification.error({
    //     title: '请求超时',
    //     message: '',
    //     position: 'bottom-right',
    //     duration:2000
    //   })

    // }
    // //  2.需要重定向到错误页面
    // const errorInfo = error.response;
    // if (errorInfo) {
    //   // error =errorInfo.data//页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
    //   if (errorInfo.status === 403) {
    //     // router.push({
    //     //   path: '/error/403'
    //     // })
    //   }
    // }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js